/* eslint-disable */
import vuetify from 'vuetify/lib/locale/en'

const labels = {
    dashboard: 'Dashboard',
    demand: 'Demand',
    demands: 'Demands',
    contract: 'Contract',
    contracts: 'Contracts',
    corporate: 'Corporate',
    brand: 'Brand',
    brands: 'Brands',
    department: 'Department',
    departments: 'Departments',
    teamMember: 'Team Member',
    teamMembers: 'Team Members',
    legalTeam: 'Legal Team',
    notification: 'Notification',
    notifications: 'Notifications',
    portfolio: 'Portfolio',
    portfolios: 'Portfolios',
    teamMemberPortfolio: 'Team',
    activeDemands: 'Active Demands',
    demandsCompleted: 'Completed Demands',
    workedHours: 'Worked Hours',
    info: 'Information',
    timeline: 'Timeline'
};

const common = {
    meta: {
        title: 'Tasklaw - %page',
        description: 'With our corporate calculator, you can manage your captable, stock options, and information about your shareholding in the company, considering the size of the round, valuation, and other factors.',
        keywords: 'calculator,corporate,captable,equity,stock,company,options,legal,shares,quotas,percentage,software,partners,shareholders,round,investment,chart,history,corporate,capital,shareholding,society'
    },
    filter: {
        componentName: 'Filters',
        searchFor: 'Search',
        byCompany: 'Filter by company',
        byDepartment: 'Filter by department',
        byResponsible: 'Filter by responsible',
        clearFilter: 'Clear filter',
        applyFilter: 'Apply filter'
    },
    search: {
        field: 'Search',
        button: 'Search'
    },
    showInactives: 'Show inactive?',
    dataTable: {
        headers: {
            name: 'Name',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours,
            actions: 'Actions'
        },
        loadingText: 'Loading... please wait',
        noDataText: 'No records found',
        deleteConfirm: 'Are you sure you want to delete this',
        view: 'View'
    },
    save: 'Save',
    add: 'Add',
    edit: 'Edit',
    change: 'Change',
    close: 'Close',
    update: 'Update',
    cancel: 'Cancel',
    confirm: 'Confirm',
    remove: 'Remove',
    details: 'Details',
    delete: 'Delete',
    previous: 'Previous',
    next: 'Next',
    notInformed: 'Not Informed',
    yes: 'Yes',
    no: 'No',
    loadMore: 'Load more',
    editorEmptyNodeText: 'Write a question or update...',
    editorObservationEmptyNodeText: 'Write an observation...',
    noDataText: 'No records found',
    timeline: {
        componentName: labels.timeline,
        newInteraction: 'New Interaction',
        correctDate: {
            label: 'Start Date (Required)',
            rule: 'Start date is required'
        },
        category: {
            label: 'Category (Required)',
            labelFilter: 'Filter by category',
            rule: 'Category is required',
            items: {
                noteFile: 'Note/File',
                meeting: 'Meeting',
                phone: 'Phone Call',
                email: 'Email',
                charge: 'Charge'
            }
        },
        alerts: {        
            saveError: 'Unable to save the interaction',
            addCommentOrFile: 'Add a Comment or a File',
            deleteConfirm: 'Are you sure you want to delete this Interaction?',
            deleteSuccess: 'Interaction successfully removed!'
        }
    },
    tabDemands: {
        addItem: 'Register Demand',
        tabs: {
            actives: 'Active',
            completeds: 'Completed',
            standby: 'Standby'
        },
        dataTable: {
            headers: {
                client: 'Client',
                startDate: 'Start Date',
                demand: labels.demand,
                currentTask: 'Current Task',
                nextTask: 'Next Task',
                deadlineDate: 'Deadline',
                status: 'Status',
                workedHours: 'Worked Hours',
                endDate: 'Completion Date',
                responsibleName: 'Responsible',
            }
        }
    },
    checkAll: 'Check All',
    uncheckAll: 'Uncheck All',
    fileInfo: {
        delete: 'Delete',
        download: 'Download',
        confirm: 'Are you sure you want to delete the file',
        success: 'File successfully removed'
    },
    chat: {
        action: 'Use AI',
        title: 'Chat',
        you: 'You',
        system: 'System',
        message: 'Type your message',
        error: 'An error occurred!'
    },
    errorSave: 'An error occurred while saving!',
    admin: 'Administrator',
    noAdmin: 'Non-administrator'
}

const demand = {
    status: {
        pending: "Pending",
        starting: "Started",
        waiting: "Waiting",
        standby: "Standby",
        finished: "Finished",
        canceled: "Canceled",
    },
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.demands),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filter by start date',
            toDate: 'Filter by end date',
            client: 'Filter by company',
            department: 'Filter by department',
            manager: 'Filter by partner',
            responsible: 'Filter by responsible',
            status: 'Filter by status'
        },
        addItem: 'Register Demand',
        dataTable: {
            itemName: labels.demand.toLowerCase(),
            headers: {
                client: 'Company',
                startDate: 'Start Date',
                demand: labels.demand,
                currentTask: 'Current Task',
                nextTask: 'Next Task',
                deadlineDate: 'Deadline',
                status: 'Status',
                responsible: 'Responsible'
            }
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Register Demand'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: common.meta.title.replace('%page', 'Demand Detail'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'New Demand',
        titleDetail: 'Demand Detail',
        data: 'Demand Data',
        isExternalDemand: 'Is this an external demand?',
        demand: {
            label: 'Demand (Required)',
            required: 'Demand is required',
            length: 'The demand must have at least 3 characters'
        },
        requester: {
            label: 'Requester'
        },
        client: {
            label: 'Search client (Required)',
            required: 'Client is required'
        },
        department: {
            label: 'Search department'
        },
        responsible: {
            label: 'Search responsible persons (Required)',
            length: 'Responsible is required'
        },
        status: {
            label: 'Status (Required)',
            required: 'Status is required'
        },
        startDate: {
            label: 'Start Date (Required)',
            required: 'Start date is required'
        },
        deadlineDate: {
            label: 'Deadline Date',
            labelRequired: 'Deadline Date (Required)',
            required: 'Deadline date is required'
        },
        manager: {
            label: 'Search partner (Required)',
            required: 'Partner is required'
        },
        workedHours: {
            label: 'Worked Hours',
            data: 'New worked hours record',
            time: {
                label: 'Worked Hours',
                rule: 'Worked hours are required'
            },
            registerDate: {
                label: 'Registration Date (Required)',
                rule: 'Registration date is required'
            }
        },
        tasks: {
            data: 'Tasks',
            task: {
                label: 'New Task',
                rule: 'Worked hours are required'
            },
            hideDoneTasks: 'Hide completed tasks',
            showDoneTasks: 'Show completed tasks'
        },
        timeline: {
            isPrivate: 'Private',
            totalFiles: 'Total files:',
            correctDate: {
                label: 'Date (Required)',
                rule: 'Date is required'
            },
            confirm: 'Are you sure you want to delete this interaction?',
            success: 'Interaction successfully removed!',
            errors: {
                save: 'Unable to save interaction',
                commentFile: 'Add a Comment or a File'
            }
        }
    }
};

const contracts = {
    status: {
        items: {
            draft: 'Drafts',
            signatures: 'Signatures',
            active: 'Active',
            renewal: 'Renewal',
            rescinded: 'Rescinded',
            terminated: 'Terminated'
        }
    },
    list: {
        meta: {
            title: 'Tasklaw - Contracts',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        filter: {
            fromDate: 'Filter by Start Date',
            toDate: 'Filter by End Date',
            status: 'Filter by Status',
            part: 'Filter by Party',
            department: 'Filter by Department',
            client: 'Filter by Company'
        },
        addItem: 'Register Contract',
        dataTable: {
            itemName: labels.contract.toLowerCase(),
            headers: {
                client: 'Company',
                department: 'Department',
                contract: 'Contract',
                typePart: 'My Party',
                part: 'Main Party',
                deadline: 'Current Deadline',
                validity: 'Validity',
                status: 'Status',
                pendingAdditive: 'Pending Addendum',
                actions: common.dataTable.headers.actions
            }
        },
        successDelete: 'Contract successfully removed!',
        error: 'An error occurred!',
        deleteMsg: 'Brand successfully removed!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - New Contract',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Contract Details',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'New Contract',
        titleDetail: 'Contract Details',
        data: 'Contract Data',
        contract: {
            label: 'Contract (Required)',
            required: 'Contract is required',
            length: 'The contract must be at least 3 characters long'
        },
        client: {
            label: 'Search for Company (Required)',
            required: 'Company is required'
        },
        department: {
            label: 'Search for Department'
        },
        partField: {
            label: 'Party (Required)',
            required: 'Party is required'
        },
        typePart: {
            label: 'Party (Required)',
            required: 'Other party is required',
            length: 'The party must be at least 3 characters long'
        },
        validity: {
            switch: 'Indeterminate validity?',
            label: 'Contract Validity (Required)',
            required: 'Contract validity is required',
            dateRequired: 'Validity date is required'
        },
        status: {
            label: 'Status (Required)',
            required: 'Status is required'
        },
        observation: 'Observations',
        objectContract: {
            label: 'Contract Object',
            required: 'Contract object is required'
        },
        part: {
            title: 'Other Parties of the Contract',
            empty: 'No parties registered in this contract!',
            isMainPart: '(Main Party)',
            setMainPart: 'Set as Main',
            showOnlyMainPart: 'Show Only Main Party',
            showAllParts: 'View All Parties in the Contract'
        },
        partDialog: {
            title: 'New Party in the Contract',
            type: {
                label: 'Party',
                required: 'Party is required',
                length: 'The party must be at least 3 characters long',
            },
            name: {
                label: 'Party Name',
                required: 'Party name is required',
                length: 'The party name must be at least 3 characters long'
            },
            part: {
                label: 'Party'
            }
        },
        fileUpload: {
            title: 'Contract File',
            empty: 'No file attached!',
            tip: 'Drag and drop the file here or click the button below.',
            action: 'Attach'
        },
        deadline: {
            title: 'Contract Deadlines',
            empty: 'No deadlines registered in this contract!',
            hideDones: 'Hide Completed Deadlines',
            showDones: 'View Completed Deadlines'
        },
        deadlineDialog: {
            title: 'New Contract Deadline',
            deadline: {
                label: 'Deadline Date (Required)',
                required: 'Deadline date is required'
            },
            name: {
                label: 'New Deadline',
                required: 'Deadline name is required',
                length: 'The deadline name must be at least 3 characters long'
            }
        },
        additive: {
            title: 'Contract Addendums',
            empty: 'No addendums registered in this contract!',
            status: 'Addendum Status:',
            signDate: 'Signature Date:',
            cancelDate: 'Cancellation Date:',
            hideCanceleds: 'Hide Canceled Addendums',
            showCanceleds: 'Show Canceled Addendums'
        },
        additiveDialog: {
            title: 'Contract Addendum',
            empty: 'No contract object attached!',
            additive: {
                label: 'Name (Required)',
                required: 'Name is required',
                length: 'The name must be at least 3 characters long'
            },
            description: 'Addendum Description and Object',
            reasonCancellation: {
                label: 'Reason for Cancellation (Required)',
                required: 'Reason for cancellation is required'
            },
            addendumDate: {
                label: 'Creation Date (Required)',
                required: 'Addendum creation date is required'
            },
            signatureDate: {
                label: 'Signature Date (Required)',
                required: 'Addendum signature date is required'
            },
            cancellationDate: {
                label: 'Cancellation Date (Required)',
                required: 'Addendum cancellation date is required'
            },
            status: {
                label: 'Status (Required)',
                required: 'Status is required',
                items: {
                    pending: 'Pending',
                    sign: 'Signed',
                    canceled: 'Canceled'
                }
            }
        }
    }
};

const corporate = {
    meta: {
        title: 'Tasklaw - Corporate',
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    tabs: {
        captable: 'Captable',
        administration: 'Administration',
        constitutiveActs: 'Constitutive Acts'
    },
    client: {
        label: common.filter.byCompany,
    },
    captable: {
        companyInfo: {
            update: 'Update Data',
            socialReason: 'Company Name',
            socialObjects: 'Business Objects',
            CNAES: 'CNAES',
            headquarters: 'Headquarters',
            companyType: {
                label: 'Corporate Type',
                required: 'Corporate type is required',
                items: {
                    sa: 'SA',
                    ltda: 'Ltda'
                }
            },
            meetingDate: {
                label: 'AGO Date',
                required: 'Date is required'
            },
            shareCapitalLabel: 'Total Shares',
            totalActions: 'Total Shares',
            totalQuotas: 'Total Quotas',
            agoDate: 'AGO Date',
            partnersMeetingDate: 'Partners Meeting Date'
        },
        current: {
            title: 'Current Captable',
            empty: 'No current entry at the moment!',
        },
        history: {
            title: 'Captable History',
            empty: 'No history at the moment!',
            headers: {
                shareholder: 'Shareholder',
                actions: 'Shares',
                percentual: '%',
                partners: 'Partners',
                quotas: 'Quotas'
            },
            total: 'Total',
            deleteConfirm: 'Are you sure you want to delete this Captable?',
            deleteSuccess: 'Captable successfully deleted!'
        },
        form: {
            titleNew: 'New Entry',
            titleDetail: 'Entry Details',
            data: 'Entry Data',
            memberTypeShareholders: 'Shareholders',
            shareTypeActions: 'Shares',
            memberTypePartners: 'Partners',
            shareTypeQuotas: 'Quotas',
            shareCapitalInitial: 'Initial Quotas',
            shareCapitalBase: 'Updated Quotas',
            buttonLabelAdd: 'Add',
            buttonLabelEdit: 'Edit',
            groupEntry: 'Group % entry?',
            columns: {
                name: 'Name',
                percentual: 'Percentage',
                shares: 'Shares',
                stakes: 'Quotas'
            },
            empty: 'No members registered!',
            shareNumberRounded: '* The number of %form.shareType% is rounded to the nearest whole number *',
            unlockChanges: 'Unlock changes',
            lockChanges: 'Lock changes',
            calc: 'Calculate',
            reInit: 'Reset',
            title: {
                label: 'Title (Required)',
                required: 'Title is required',
                length: 'Title must be at least 3 characters long'
            },
            shareCapitalInitial: {
                label: 'Initial Shares',
                required: 'Initial shares are required',
                length: 'Initial shares must be positive'
            },
            shareCapitalBase: {
                label: 'Updated Shares',
                required: 'Updated shares are required',
                length: 'Updated shares must be positive'
            },
            required: 'Required',
            member: {
                required: 'Member is required',
                length: 'Title must be at least 3 characters long'
            },
            shares: {
                required: 'Shares are required',
                length: 'Shares must be positive'
            },
            percentual: {
                required: 'Percentage is required',
                length: 'Percentage must be positive',
                lengthMore: 'Percentage cannot exceed 100%'
            },
            fixedError: 'Incorrect calculation: the sum of fixed percentages is 100% or above!',
            addedError: 'Incorrect calculation: the sum of added percentages is 100% or above!',
            fixedAddedError: 'Incorrect calculation: the sum of fixed and added percentages is 100% or above!',
            missingMembers: 'You need to add members!'
        }
    },
    administration: {
        titleSA: 'Board of Directors',
        titleLTDA: 'Directors/Administrators',
        current: {
            empty: 'No members at the moment!',
        },
        history: {
            title: '%title% History',
            empty: 'No history at the moment!',
            registerDate: 'Registration Date:',
            admitted: 'Admitted',
            destitute: 'Removed',
            headers: {
                name: 'Directors/Administrators',
                nameSA: 'Board of Directors',
                position: 'Position',
                election: 'Election',
                mandate: 'Mandate',
                deprived: 'Removed'
            },
            deleteConfirm: 'Are you sure you want to delete this record?',
            deleteSuccess: 'Record successfully deleted!'
        },
        form: {
            titleNew: 'New Entry',
            titleDetail: 'Entry Details',
            data: 'Entry Data',
            memberTypeLTDA: 'Directors/Administrators',
            memberTypeSA: 'Board of Directors',
            admitted: '(Admitted)',
            destitute: '(Removed)',
            empty: 'No members registered!',
            dismiss: 'Remove',
            refund: 'Reinstate',
            date: {
                label: 'Registration Date (Required)',
                required: 'Registration Date is required'
            },
            member: {
                label: 'Name (Required)',
                required: 'Name is required',
                length: 'Name must be at least 3 characters long'
            },
            position: {
                label: 'Position (Required)',
                required: 'Position is required',
                length: 'Position must be at least 3 characters long'
            },
            mandate: {
                label: 'Indeterminate mandate?',
                required: 'Mandate date is required',
                length: 'Mandate must be at least 3 characters long',
                undetermined: 'Indeterminate'
            },
            election: {
                label: 'Election (Required)',
                required: 'Election date is required'
            },
            deprived: {
                label: 'Removal (Required)',
                required: 'Removal date is required'
            }
        }
    },
    constitutiveActs: {
        fromDate: 'After',
        toDate: 'Before',
        dataTable: {
            itemName: 'Constitutive Act',
            headers: {
                date: 'Date',
                title: 'Title',
                resume: 'Summary',
                file: 'Attachment',
                actions: 'Actions'
            }
        },
        form: {
            header: 'Constitutive Act',
            filePreviewEmpty: 'No act file attached!',
            title: {
                label: 'Title (Required)',
                required: 'Title is required',
                length: 'Title must be at least 3 characters long'
            },
            description: {
                label: 'Act Summary and File',
            },
            time: {
                label: 'Time (Required)',
                required: 'Time is required'
            },
            date: {
                label: 'Date (Required)',
                required: 'Date is required'
            },
            needFile: 'You must attach a file.',
            needResume: 'You must fill in the summary.'
        }
    }
};

const brands = {
    list: {
        meta: {
            title: 'Tasklaw - Brands',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Register Brand',
        dataTable: {
            itemName: labels.brand.toLowerCase(),
            headers: {
                company: 'Company',
                process: 'Process',
                brand: 'Brand',
                presentation: 'Presentation',
                nature: 'Nature',
                class: 'Class',
                situation: 'Situation',
                actions: 'Actions'
            }
        },
        deleteMsg: 'Brand successfully removed!'
    },
    form: {
        metaNew: {
            title: 'Tasklaw - New Brand',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaDetail: {
            title: 'Tasklaw - Brand Details',
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        titleNew: 'New Brand',
        titleDetail: 'Brand Details',
        data: 'Brand Data',
        processNo: 'Process No.',
        searchINPI: 'Search in INPI',
        processNumberRequired: 'Process No. (Required)',
        processNumberIsRequired: 'Process No. is required',
        searchCompanyRequired: 'Search company (Required)',
        companyIsRequired: 'Company is required',
        inpiError: 'Oops! There was a problem with INPI.',
        processNumber: 'Process Number',
        situation: 'Situation',
        brand: 'Brand',
        presentation: 'Presentation',
        nature: 'Nature'
    }
};

const client = {
    info: {
        primaryEmail: 'Primary Email',
        commercialPhone: 'Commercial Phone',
        cellPhone: 'Cell Phone',
        comments: 'Comments',
        isActive: {
            portfolio: 'Is the portfolio active?',
            department: 'Is the department active?'
        }
    },
    workedHours: {
        fromDate: 'After',
        toDate: 'Before',
        responsible: 'Filter by Responsible',
        dataTable: {
            itemName: 'worked hour',
            headers: {
                registeredAt: 'Registration Date',
                demand: 'Demand',
                workedHour: 'Worked Hours',
                responsibleName: 'Responsible',
                actions: 'Actions'
            },
            deleteSuccess: 'Worked hour successfully removed!'
        }
    },
    contracts: {
        addItem: 'Register Contract',
        tabs: {
            active: 'Active',
            inactive: 'Inactive'
        },
        dataTable: {
            itemName: 'contract',
            headers: {
                contract: 'Contract',
                typePart: 'Party',
                part: 'Main Party',
                deadline: 'Current Deadline',
                validity: 'Validity',
                status: 'Status',
                pendingAdditive: 'Pending Additive'
            }
        }
    }
};

const portfolios = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.portfolios),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Register Portfolio',
        dataTable: {
            itemName: labels.portfolio.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Register Portfolio'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Portfolio Data',
        name: {
            label: 'Portfolio Name (Required)',
            required: 'Name is required',
            length: 'The name must be at least 3 characters long'
        },
        primaryEmail: {
            label: 'Primary Email (Required)',
            required: 'Email is required',
            test: 'Email must be valid'
        },
        commercialPhone: 'Commercial Phone',
        cellPhone: 'Cell Phone',
        comments: 'Comments'
    },
    teamMember: {
        addItem: 'Register User',
        dataTable: {
            itemName: 'user',
            headers: {
                name: 'User',
                jobTitle: 'Job Title',
                phone: 'Phone',
                username: 'Email',
                mainAccount: 'Access Type',
                actions: 'Actions'
            },
            deleteSuccess: 'Relation successfully removed!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Register User'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'User Data',
            name: {
                label: 'Name (Required)',
                required: 'Name is required',
                length: 'The name must be at least 3 characters long'
            },
            jobTitle: {
                label: 'Job Title (Required)',
                required: 'Job title is required',
                length: 'The job title must be at least 3 characters long'
            },
            phone: {
                label: 'Phone (Required)',
                required: 'Phone is required',
                length: 'The phone number must be at least 8 characters long'
            },
            username: {
                label: 'Email (Required)',
                required: 'Email is required',
                test: 'Email must be valid'
            },
            pickColor: 'Pick a color',
            mainAccount: {
                label: 'Administrator?',
                required: 'Access type is required',
                items: {
                    admin: 'Administrator',
                    user: 'User'
                }
            },
            errorUpdateAdmin: 'An error occurred while updating the administrator status!',
            errorRelation: 'An error occurred, the legal entity was created but not linked to the organization!',
            errorCreate: 'An error occurred and it was not possible to create the legal entity!'
        }
    }
};

const departments = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.departments),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Register Department',
        dataTable: {
            itemName: labels.department.toLowerCase(),
            headers: {
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            }
        }
    },
    form: {
        meta: {
            title: common.meta.title.replace('%page', 'Register Department'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Department Data',
        name: {
            label: 'Department Name (Required)',
            required: 'Name is required',
            length: 'The name must be at least 3 characters long'
        },
        primaryEmail: {
            label: 'Primary Email (Required)',
            required: 'Email is required',
            test: 'Email must be valid'
        },
        commercialPhone: 'Commercial Phone',
        cellPhone: 'Cell Phone',
        comments: 'Comments',
        isActive: 'Is the department active?'
    },
    teamMember: {
        addItem: 'Register Team Member',
        dataTable: {
            itemName: 'team member',
            headers: {
                name: 'Team Member',
                mainAccount: 'Access Type',
                actions: 'Actions'
            },
            deleteSuccess: 'Relation with department successfully removed!'
        },
        form: {
            meta: {
                title: common.meta.title.replace('%page', 'Register Team Member'),
                description: common.meta.description,
                keywords: common.meta.keywords
            },
            data: 'Team Member Data',
            name: {
                label: 'Name (Required)',
                required: 'Name is required',
                length: 'The name must be at least 3 characters long'
            },
            jobTitle: {
                label: 'Job Title (Required)',
                required: 'Job title is required',
                length: 'The job title must be at least 3 characters long'
            },
            phone: {
                label: 'Phone (Required)',
                required: 'Phone is required',
                length: 'The phone number must be at least 8 characters long'
            },
            username: {
                label: 'Email (Required)',
                required: 'Email is required',
                test: 'Email must be valid'
            },
            pickColor: 'Pick a color',
            mainAccount: {
                label: 'Administrator?',
                required: 'Access type is required',
                items: {
                    admin: 'Administrator',
                    user: 'User'
                }
            },
            errorUpdateAdmin: 'An error occurred while updating the administrator status!',
            errorRelation: 'An error occurred, the user was created but not linked to the company!',
            errorCreate: 'An error occurred and it was not possible to create the user!',
            errorUploadAvatar: 'Failed to upload avatar!'
        }
    }
};

const legalTeam = {
    list: {
        meta: {
            title: common.meta.title.replace('%page', labels.legalTeam),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        addItem: 'Register Legal Team',
        dataTable: {
            itemName: labels.legalTeam.toLowerCase(),
            headers: {
                avatar: 'Avatar',
                name: common.dataTable.headers.name,
                activeDemands: common.dataTable.headers.activeDemands,
                demandsCompleted: common.dataTable.headers.demandsCompleted,
                workedHours: common.dataTable.headers.workedHours,
                actions: common.dataTable.headers.actions
            },
            isInactiveMessage: 'Are you sure you want to disable this?',
            isActiveMessage: 'Are you sure you want to enable this?',
            fbActiveMessage: 'Legal team successfully enabled!',
            fbInactiveMessage: 'Legal team successfully disabled!'
        }
    },
    form: {
        metaNew: {
            title: common.meta.title.replace('%page', 'Register Legal Team'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        metaEdit: {
            title: common.meta.title.replace('%page', 'Edit Legal Team'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        data: 'Legal Team Data',
        save: common.save,
        avatar: {
            placeholder: 'Avatar',
        },
        name: {
            placeholder: 'Name (Required)',
            errors: {
                required: 'Name is required',
                length: 'The name must be at least 3 characters long'
            }
        },
        email: {
            placeholder: 'Email (Required)',
            errors: {
                required: 'Email is required',
                length: 'Email must be valid'
            }
        },
        jobTitle: {
            placeholder: 'Job Title (Required)',
            errors: {
                required: 'Job title is required',
                length: 'The job title must be at least 3 characters long'
            }
        },
        phone:  {
            placeholder: 'Phone (Required)',
            errors: {
                required: 'Phone is required',
                length: 'The phone number must be at least 8 characters long'
            }
        },
        selectColor: 'Choose a color',
        isAdmin: 'Is administrator?',
        adminStatusUpdateError: 'An error occurred while updating the administrator status!',
        legalCreatedButNotLinkedError: 'An error occurred, the legal team was created but not linked to the organization!',
        legalCreationError: 'An error occurred and it was not possible to create the legal team!',
        avatarUploadError: 'Failed to upload avatar!'
    },
    detail: {
        meta: {
            title: common.meta.title.replace('%page', 'Legal Team Detail'),
            description: common.meta.description,
            keywords: common.meta.keywords
        },
        tabs: {
            legalTeam: labels.legalTeam,
            demands: labels.demands,
            timeline: labels.timeline
        },
        fields: {
            admin: 'Administrator',
            name: 'Name',
            email: 'Email',
            jobTitle: 'Job Title',
            phone: 'Phone',
            activeDemands: labels.activeDemands,
            demandsCompleted: labels.demandsCompleted,
            workedHours: labels.workedHours
        }
    }
};

const notifications = {
    meta: {
        title: common.meta.title.replace('%page', labels.notifications),
        description: common.meta.description,
        keywords: common.meta.keywords
    },
    filter: {
        searchFor: common.filter.searchFor,
        byDepartment: common.filter.byDepartment,
        byResponsible: common.filter.byResponsible,
        clearFilter: common.filter.clearFilter,
        applyFilter: common.filter.applyFilter
    },
    sideMenu: {
        boxes: 'Boxes',
        my: 'My',
        distribution: 'Distribution',
        admin: 'Administrator',
        archived: 'Archived',
        archivedAdmin: 'Archived Administrator'
    },
    dotMenu: {
        markAllRead: 'Mark all as read',
        archiveAll: 'Archive all'
    },
    tile: {
        demand: labels.demand,
        archiveActions: {
            archive: 'Archive',
            unarchive: 'Unarchive'
        },
        readActions: {
            markRead: 'Mark as read',
            markUnread: 'Mark as unread'
        },
        lastSeen: 'Last seen by the current responsible on',
        neverSeen: 'Never',
        demandNotFound: 'Demand not found or removed!'
    }
};

export default {
    labels,
    common,
    demand,
    contracts,
    corporate,
    brands,
    client,
    portfolios,
    departments,
    legalTeam,
    notifications,
    $vuetify: vuetify
}